<template>
	<div>
		<h5>FaultTreatment</h5>
	</div>
</template>

<script>
	export default {
		name: "FaultTreatment",
	};
</script>

<style scoped></style>
